module.exports = __webpack_public_path__ + "static/media/harding_logo2.cf587f29.png~";